const services = [
    {
        title: "Staff Recruitment & Supply",
        description:
            "Flexible staffing solutions for healthcare, care, and support settings, helping organizations access dependable professionals when they need them most.",
        link: "/services/recruitment",
        icon: "👥",
    },
    {
        title: "Mental Health Staff Training",
        description:
            "Specialist training designed to strengthen staff confidence, awareness, and day-to-day mental health support practice.",
        link: "/services/training",
        icon: "🧠",
    },
    {
        title: "Domiciliary Care Including Live-In",
        description:
            "Compassionate at-home care and live-in support focused on dignity, independence, safety, and comfort.",
        link: "/services/domiciliary-care",
        icon: "🏠",
    },
    {
        title: "Children’s Services",
        description:
            "Support services that prioritize safeguarding, wellbeing, development, and child-centered care outcomes.",
        link: "/services/childrens-services",
        icon: "🌟",
    },
    {
        title: "Secure Transport Services",
        description:
            "Professional transport arrangements for individuals requiring secure, structured, and respectful transfers.",
        link: "/services/secure-transport",
        icon: "🛡️",
    },
];

export default services;
